<template>
  <div>
    <el-form
      :rules="rules"
      ref="ruleForm"
      :model="ruleForm"
      label-position="top"
      label-width="100px"
      class="formBox"
    >
      <el-form-item label="园区" prop="park_id">
        <el-select
          filterable
          v-model="ruleForm.park_id"
          placeholder="请选择园区"
          :disabled="userInfo.is_super != 1"
          @change="parkChange"
        >
          <el-option
            :label="item.name"
            :value="item.id"
            v-for="(item, index) in parkList"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="标题" prop="title">
        <el-input
          :disabled="disabled"
          style="width: 200px"
          v-model="ruleForm.title"
          placeholder="请输入标题"
        ></el-input>
      </el-form-item>
      <el-form-item label="单人价格" prop="price">
        <el-input
          :disabled="disabled"
          style="width: 200px"
          class="numInput"
          type="number"
          min="0"
          v-model="ruleForm.price"
          placeholder="请输入单人价格"
          ><template slot="append">元</template></el-input
        >
      </el-form-item>
      <el-form-item label="开放天数" prop="open_week">
        <el-checkbox-group v-model="ruleForm.open_week" :disabled="disabled">
          <el-checkbox label="1" name="type">星期一</el-checkbox>
          <el-checkbox label="2" name="type">星期二</el-checkbox>
          <el-checkbox label="3" name="type">星期三</el-checkbox>
          <el-checkbox label="4" name="type">星期四</el-checkbox>
          <el-checkbox label="5" name="type">星期五</el-checkbox>
          <el-checkbox label="6" name="type">星期六</el-checkbox>
          <el-checkbox label="7" name="type">星期日</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="开放开始时间段" prop="open_start_time">
        <el-time-picker
          :disabled="disabled"
          arrow-control
          value-format="HH:mm:ss"
          v-model="ruleForm.open_start_time"
          placeholder="任意时间点"
        >
        </el-time-picker>
      </el-form-item>
      <el-form-item label="开放结束时间段" prop="open_end_time">
        <el-time-picker
          :disabled="disabled"
          arrow-control
          value-format="HH:mm:ss"
          v-model="ruleForm.open_end_time"
          placeholder="任意时间点"
        >
        </el-time-picker>
      </el-form-item>
      <el-form-item label="轮播图" prop="image">
        <el-upload
          :disabled="disabled"
          name="file[]"
          :data="{ type: 'image' }"
          ref="upload"
          :class="{ disabled: uploadDisabled }"
          :file-list="fileList"
          :headers="{ token: token }"
          :action="ossUpload"
          list-type="picture-card"
          :on-preview="handlePictureCardPreview"
          :on-remove="handleRemove"
          :before-upload="beforeAvatarUpload"
          :on-success="handleAvatarSuccess"
          :on-change="handleEditChange"
          accept=".jpg,.png,.jpeg"
        >
          <i class="el-icon-plus"></i> </el-upload
        ><!-- 已修改 -->
        <el-dialog :append-to-body="true" :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
      </el-form-item>
      <el-form-item label="地址" prop="address" class="w50">
        <el-input
          type="textarea"
          :disabled="disabled"
          v-model="ruleForm.address"
          placeholder="请输入地址"
        ></el-input>
      </el-form-item>
      <el-form-item label="详细介绍" prop="details">
        <Editor
          :disabled="disabled"
          ref="myQuillEditor"
          style="width: 100%"
          v-model="ruleForm.details"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')"
          >编辑</el-button
        >
        <el-button @click="resetForm('ruleForm')">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import Editor from "@/components/Editor";
import { delImage, openPark } from "@/api/index";
import { fishingInfo, fishingEdit } from "@/api/smartFarm";
import { mapGetters } from "vuex";
import { getToken } from "@/utils/auth";
export default {
  components: { Editor },
  computed: {
    ...mapGetters(["roles", "userInfo", "imageOss"]),
  },
  data() {
    return {
      token: getToken(),
      ruleForm: {
        park_id: "",
        id: "",
        title: "",
        price: "",
        open_week: [],
        open_start_time: "",
        open_end_time: "",
        banner: [],
        image: [],
        address: "",
        details: "",
      },
      fileList: [],
      file: [],
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      uploadDisabled: false,
      ossUpload: this.$store.state.ossUpload,
      rules: {
        park_id: [{ required: true, message: "请选择园区"  }],
        title: [{ required: true, message: "请输入标题"}],
        price: [{ required: true, message: "请输入单人价格"}],
        open_week: [{ required: true, message: "请选择开放天数" }],
        open_start_time: [
          {
            required: true,
            message: "请选择开放开始时间段",
          },
        ],
        open_end_time: [
          {
            required: true,
            message: "请选择开放结束时间段",
          },
        ],
        image: [
          {
            type: "array",
            required: true,
            message: "请选择轮播图",
            trigger: "change",
          },
        ],
        address: [{ required: true, message: "请输入地址", trigger: "blur" }],
        details: [{ required: true, message: "请填写详情", trigger: "blur" }],
      },
      parkList: [],
      disabled: true,
    };
  },
  created() {
    if (this.userInfo.is_super !== 1) {
      this.ruleForm.park_id = this.userInfo.park_id;
      this.disabled = false;
      this.getInfo(this.userInfo.park_id);
    }
    this.getPark();
  },
  methods: {
    parkChange(e) {
      this.disabled = false;
      this.getInfo(e);
    },
    getInfo(id) {
      fishingInfo({ park_id: id }).then((res) => {
        if (JSON.stringify(res.data.info) !== "{}") {
          this.ruleForm = {
            park_id: res.data.info.park_id,
            id: res.data.info.id,
            title: res.data.info.title,
            price: res.data.info.price,
            open_week: res.data.info.open_week,
            open_start_time: res.data.info.open_start_time,
            open_end_time: res.data.info.open_end_time,
            image: res.data.info.banner,
            address: res.data.info.address,
            details: res.data.info.details,
          };
          if (res.data.info.banner) {
            var list = res.data.info.banner;
            this.fileList = list.map((item) => {
              return {
                name: +new Date(),
                url: this.imageOss + item,
                response: {
                  data: {
                    url: item,
                  },
                },
              };
            });
          }
        } else {
          console.log(777)
          this.ruleForm = {
            park_id:id,
            id: "",
            title: "",
            price: "",
            open_week: [],
            open_start_time: "",
            open_end_time: "",
            banner: [],
            image: [],
            address: "",
            details: "",
          };
          this.fileList = [];
        }
      });
    },
    // 获取园区
    getPark() {
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    handleAvatarSuccess(res, file) {
      if (res.code === 200) {
        this.ruleForm.image.push(res.data.url);
      }
      this.uploadDisabled = this.ruleForm.image >= 6;
    },
    beforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
      }
      return isLt5M;
    },
    // 删除
    handleRemove(file) {
      const index = this.ruleForm.image.indexOf(file.response.data.url);
      this.delImg(file.response.data.url);
      if (index > -1) {
        this.ruleForm.image.splice(index, 1);
      }
    },
    // 查看
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 删除线上图片
    delImg(path) {
      delImage({ file: path }).then((ress) => {});
    },
    // 最多上传6张图，超过时隐藏上传按钮
    handleEditChange(file, fileList) {
      this.uploadDisabled = this.ruleForm.image.length >= 6;
    },
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            park_id: this.ruleForm.park_id,
            id: this.ruleForm.id,
            title: this.ruleForm.title,
            price: this.ruleForm.price,
            open_week: this.ruleForm.open_week.toString(),
            open_start_time: this.ruleForm.open_start_time,
            open_end_time: this.ruleForm.open_end_time,
            banner: this.ruleForm.image.toString(),
            address: this.ruleForm.address,
            details: this.ruleForm.details,
          };
          fishingEdit(data).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              this.resetForm("ruleForm");
            }
          });
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$refs.upload.clearFiles();
    },
  },
};
</script>
<style lang="scss" scoped>
.formBox {
  padding: 20px 30px;
}

::v-deep .el-form-item__label {
  line-height: 0;
}

::v-deep .disabled .el-upload--picture-card {
  display: none !important;
}

::v-deep .w50 {
  .el-textarea {
    width: 45%;
  }
  .el-input {
    width: 45%;
  }
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}

.hide {
  ::v-deep .el-upload--picture-card {
    display: none;
  }
}
//去除动画
::v-deep .el-list-enter-active,
::v-deep .el-list-leave-active {
  transition: all 0s;
}
</style>
